import update from "immutability-helper";
import { TRIPADVISOR_RESULTS_SAVE } from "../actions/hotels/types";
import {
  ACCOMMODATION_SEARCH_FILTERS_CHANGE,
  ACCOMMODATION_SEARCH_FORM_CHANGE,
  ACCOMMODATION_SEARCH_FORM_RESET,
  ACCOMMODATION_SEARCH_FORM_UPDATE,
  ACCOMMODATION_SEARCH_LOAD_STATE,
  ACCOMMODATION_SEARCH_PAYLOAD_SAVE,
  ACCOMMODATION_SEARCH_RESET_FILTER,
  ACCOMMODATION_SEARCH_SAVE_META,
  ACCOMMODATION_SEARCH_SAVE_RESULTS,
  ACCOMMODATION_SEARCH_SESSION_IDLE,
  ACCOMMODATION_SEARCH_SESSION_LOADING,
  ACCOMMODATION_SEARCH_SET_CURRENT_POLLCOUNT,
  ACCOMMODATION_SEARCH_STATE_INIT,
  ACCOMMODATION_SEARCH_STOP,
  ACCOMMODATION_SYSTEM_INIT,
} from "../actions/single_search/types";
import { DateTime } from "luxon";
import { brand } from "../context";

export function tripAdvisorReducer(state = {}, action) {
  switch (action.type) {
    case TRIPADVISOR_RESULTS_SAVE: {
      const { results } = action;
      return { ...state, ...results };
    }
    default:
      return state;
  }
}
const group = import.meta.env.VITE_APP_GROUP_NAME || "";
export function hotelFiltersInitial() {
  return {
    name: "",
    nearby: {},
    rating: [],
    board: "",
    budget: [0, 1],
    room_type: "",
    cxl_policies: [],
    provider: "",
    order_by: group === "ubook" || brand === "tmdh" ? "BIG" : "STA",
  };
}
const roomFiltersInitial = {};
const HotelSearchInitial = {
  bookingProcess: false,
  isSearching: false,
  isSessionLoading: false,
  searchData: {
    rooms: [
      {
        adults: 2,
        children: 0,
        children_ages: [],
      },
    ],
  },
  searchPayload: {},
  searchMeta: { pollCount: 0, maxPollCount: 5 },
  hotels: [],
  viewingHotel: {},
  selectedHotel: {},
  hotel_filters: { ...hotelFiltersInitial() },
  room_filters: { ...roomFiltersInitial },
};
export const HotelSearch = (state = HotelSearchInitial, action) => {
  switch (action.type) {
    case ACCOMMODATION_SYSTEM_INIT:
      return HotelSearchInitial;
    case ACCOMMODATION_SEARCH_STATE_INIT:
      return HotelSearchInitial;
    case ACCOMMODATION_SEARCH_LOAD_STATE: {
      const { data } = action;
      return { ...state, ...data };
    }
    case ACCOMMODATION_SEARCH_PAYLOAD_SAVE: {
      const { searchPayload, searchData } = action;
      return { ...state, searchPayload, searchData, isSearching: true };
    }
    case ACCOMMODATION_SEARCH_STOP:
      return { ...state, isSearching: false };
    case ACCOMMODATION_SEARCH_SESSION_LOADING:
      return { ...state, isSessionLoading: true };
    case ACCOMMODATION_SEARCH_SESSION_IDLE:
      return { ...state, isSessionLoading: false };
    case ACCOMMODATION_SEARCH_SAVE_META: {
      const { searchMeta } = action;
      return { ...state, searchMeta };
    }
    case ACCOMMODATION_SEARCH_SAVE_RESULTS: {
      const { hotels } = action;
      return { ...state, hotels };
    }
    case ACCOMMODATION_SEARCH_FILTERS_CHANGE: {
      const { value } = action;
      return { ...state, hotel_filters: value };
    }
    case ACCOMMODATION_SEARCH_RESET_FILTER: {
      const { key } = action;
      if (["board", "room_type"].includes(key)) {
        return update(state, { hotel_filters: { [key]: { $set: "" } } });
      }

      return update(state, { hotel_filters: { [key]: { $set: [] } } });
    }
    case ACCOMMODATION_SEARCH_SET_CURRENT_POLLCOUNT: {
      const { pollCount } = action;
      return { ...state, searchMeta: { ...state.searchMeta, pollCount } };
    }
    default:
      return state;
  }
};

const HotelSearchFormInitial = {
  acc_search_type: "dest",
  destination_meta: {},
  destination_code: [],
  checkIn: DateTime.now().plus({ days: 1 }).toISODate(),
  checkOut: DateTime.now().plus({ days: 7 }).toISODate(),
  rooms: [
    {
      adults: 2,
      children: 0,
      children_ages: [],
    },
  ],
  nationality: "GR",
};
export const HotelSearchForm = (state = HotelSearchFormInitial, action) => {
  switch (action.type) {
    case ACCOMMODATION_SYSTEM_INIT:
      return HotelSearchFormInitial;
    case ACCOMMODATION_SEARCH_FORM_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case ACCOMMODATION_SEARCH_FORM_UPDATE: {
      const { form } = action;
      return { ...state, ...form };
    }
    case ACCOMMODATION_SEARCH_FORM_RESET: {
      return HotelSearchFormInitial;
    }
    default:
      return state;
  }
};
